<template>
  <BaseTable
    class="custom-table"
    tableClass="table-bordered"
    hidePagination
  >
    <template #thead>
      <thead>
        <tr>
          <th>{{ $t('apps.billing.label.detail') }}</th>
          <th class="text-right">{{ $t('apps.billing.label.payamount') }}</th>
        </tr>
      </thead>
    </template>
    <template #tbody>
      <tbody>
        <tr>
          <td>
            {{ detail }}
          </td>
          <td class="text-right">
            {{ getCurrencyWithNumber(numberel(totalNumber, '0,0.[00]')) }}
          </td>
        </tr>
      </tbody>
    </template>
  </BaseTable>
</template>

<script>
import { BILLING_INVOICE_STATUS } from '../../helpers/enum'

export default {
  props: {
    detail: String,
    totalNumber: Number,
  },

  computed: {

  },
}
</script>

<style scoped>
.custom-table >>> td {
  padding: 3px 10px 3px 10px;
  font-size: 14px;
}

.custom-table >>> th {
  padding: 6px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/paymentpackage/InvoiceListTable.vue